import "core-js/modules/es.array.filter.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    notaddsystem: {
      type: Boolean,
      default: false
    },
    iseditconfig: {
      type: Boolean,
      default: false
    },
    configval: {
      type: String,
      default: ''
    },
    configvaluekey: {
      type: String,
      default: ''
    },
    canaddsystemlist: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    optionallist: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  watch: {
    optionallist: function optionallist(newVal) {
      // 监听 num 属性的数据变化
      // 作用 : 只要 num 的值发生变化,这个方法就会被调用
      // 第一个参数 : 新值
      // 第二个参数 : 旧值,之前的值
      this.optioncofig = newVal;
      this.changeconfigname(this.configval);
    }
  },
  data: function data() {
    return {
      formconfig: {
        configname: null,
        configvalue: null,
        systemid: null
      },
      config: {},
      optioncofig: [],
      configvaluelist: [],
      rules: {
        configname: [{
          required: true,
          message: '请选择配置名称',
          trigger: 'blur'
        }],
        configvalue: [{
          required: true,
          message: '请选择配置值',
          trigger: 'blur'
        }],
        system: [{
          required: true,
          message: '请选择子系统名称',
          trigger: 'blur'
        }]
      }
    };
  },
  created: function created() {
    if (this.iseditconfig) {
      this.formconfig.configname = this.configval;
      this.formconfig.configvalue = this.configvaluekey;
      // this.changeconfigname(this.configval)
    } else {
      // this.formconfig.configname = null
      // this.formconfig.configvalue = null
    }
  },
  methods: {
    cancelDailog: function cancelDailog() {
      this.$emit('AddconfigSubmit', {
        bool: false
      });
    },
    confirmsure: function confirmsure(bool) {
      if (bool) {
        this.commit();
      }
    },
    namefocus: function namefocus() {
      this.formconfig.configvalue = '';
    },
    changeconfigname: function changeconfigname(item) {
      var _this = this;
      // eslint-disable-next-line array-callback-return
      this.optioncofig.filter(function (val) {
        if (val.key === item) {
          _this.configvaluelist = val.children;
        }
      });
    },
    commit: function commit() {
      var _this2 = this;
      var selectvalue = '';
      // eslint-disable-next-line array-callback-return
      this.configvaluelist.filter(function (item) {
        if (item.key === _this2.formconfig.configvalue) {
          selectvalue = item.value;
        }
      });
      this.$refs.formconfig.validate(function (valid) {
        if (valid) {
          if (_this2.notaddsystem) {
            _this2.config = {
              bindDictCode: _this2.formconfig.configname,
              configOrder: 1,
              moduleType: 1,
              systemId: 1,
              value: {
                configKey: _this2.formconfig.configvalue,
                configValue: selectvalue
              }
            };
            _this2.$emit('AddconfigSubmit', {
              bool: true,
              formData: _this2.config
            });
          } else {
            _this2.$emit('Addconfigsystem', {
              system: _this2.formconfig.system
            });
          }
        } else {
          _this2.$message({
            message: '请完善信息填写',
            type: 'warning'
          });
          return false;
        }
      });
    }
  }
};